import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {catchError, map, of, throwError} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {GameService} from "../services/game.service";
import {inject} from "@angular/core";

export const GameSelectedGuard = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const gameService: GameService = inject(GameService);
  const router: Router = inject(Router);

  const gameIdFromRoute = route.paramMap.get('gameId');
  const activeGameInstate = gameService.activeGame()?.Id;

  // game is already set in state so continue with navigation
  if (activeGameInstate && gameIdFromRoute === activeGameInstate) {
    return true;
  }
  // the game is not in state
  if (gameIdFromRoute) {

    return gameService.getGameByGameId(gameIdFromRoute).pipe(
      map((gameP) => {
        if (gameP) {
          gameService.updateActiveGame(gameP);
          return true;
        }

        return false;
      }),
      catchError((errorP) => errorP instanceof HttpErrorResponse && errorP.status === 403
        ? of(router.parseUrl('/not-authorized'))
        : throwError(() => errorP))
    );
  }

  return router.navigateByUrl('');
}
